import Vue from 'vue';
import Main from './main.vue';

let LoadingConstructor = Vue.extend(Main);
let component;

LoadingConstructor.prototype.hide = function() {
  this.show = false;
};

LoadingConstructor.prototype.update = function(text) {
  this.text = text;
  this.show = true;
};

const show = function(options) {
  options = options || {};
  if (typeof options === 'string') {
    options = {
      text: options
    };
  }
  options.text = options.text || '加载中';
  if(component) {
    component.update(options.text);
  } else {
    component = new LoadingConstructor({
      data: options
    }).$mount();
    document.body.appendChild(component.$el);
  }
};
const hide = function() {
  component && component.hide();
};

export default {
  show,
  hide
};

